<section class="event" (click)="eventRegister()">
    <div class="event__date-box">
        <span class="event__day">{{ event.dayOfWeek }}</span>
        <div class="event__date">
            <span class="event__month">{{ event.monthAbbreviation }}</span>
            <span class="event__date-of-month">{{ event.day }}</span>
        </div>
    </div>
    <div class="event__details">
        <div class="event__venue">
            <span>{{ event.Name }}</span>
            <span *ngIf="event.IsWaitListOnly" class="event__waitlist"> (Waitlist Only)</span>
        </div>
        <div class="event__info">
            <span class="event__time">{{ event.time }}</span>&nbsp;<span class="event__timezone">{{ event.timeZone }}</span> -
            <span class="event__address">{{ event.Address.AddressLine1 }}, {{ event.Address.City }}, {{ event.Address.State }} {{ event.Address.Zip }}</span>
        </div>
    </div>
    <div class="event__map">
        <a href="https://www.google.com/maps?q={{ event.Address.AddressLine1 }}, {{ event.Address.City }}, {{ event.Address.State }} {{ event.Address.Zip }}" target="_blank" rel="noopener">
            <svg class="event__map-icon" style="enable-background:new 0 0 100 100;" viewBox="0 0 100 100">
                <g>
                    <g>
                        <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"/>
                        <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"/>
                        <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"/>
                        <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"/>
                    </g>
                    <path d="M50,2.5c-17.8,0-32.2,14.4-32.2,32.2c0,20.1,19.1,48.5,27.8,60.6c2.2,3,6.5,3,8.7,0c8.8-12.1,27.9-40.5,27.9-60.6    C82.2,16.9,67.8,2.5,50,2.5z M50.2,50.1c-8.6,0-15.6-7-15.6-15.6c0-8.6,7-15.6,15.6-15.6c8.6,0,15.6,7,15.6,15.6    C65.8,43.2,58.8,50.1,50.2,50.1z"/>
                </g>
            </svg>
        </a>
    </div>
</section>